export const ID = '781cafac-84fa-4bce-9d8a-439d07d561d1';

export const NAME = 'NavigationV2';
